
















































































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import UserMenu from "@/components/UserMenu.vue";
import IResource from '@/interfaces/IResource';
import IUser from '@/interfaces/IUser';

@Component({
	components: {
		UserMenu
	}
})
export default class MainPanel extends Vue {

	private resourceOpen: {[id: number]: boolean} = {};

	get user(): IUser {
		return this.$store.state.user;
	}

	get resources(): IResource[] {
		return this.$store.state.resources;
	}

	@Watch('resources', { immediate: true })
	public watchResources() {
		// open first resource by default on load
		if (this.resources.length > 0 && !this.resourceOpen[this.resources[0].id]) {
			this.$set(this.resourceOpen, this.resources[0].id, true);
		}
	}

	public async mounted(): Promise<void> {
		this.$store.dispatch('loadResources', {root: true});
	}

	public closeSidebar() {
		document.body.classList.remove('sidebar-open');
	}

	public toggleResource(id: number) {
		if (this.resources.length > 1) {
			this.$set(this.resourceOpen, id, !this.resourceOpen[id]);
		}
	}

	public toggleSidebar() {
		const el = document.body;
		el.classList.toggle('sidebar-collapse');
		el.classList.toggle('sidebar-open');
	}
}
